// extracted by mini-css-extract-plugin
export default {"Box":"use-issue-type-editor-module__Box__gdyrZY6","Box_1":"use-issue-type-editor-module__Box_1__QMdLFsb","ColorDecorator":"use-issue-type-editor-module__ColorDecorator__lgXrAEQ"};